import { Directive, ElementRef, Output, EventEmitter, OnInit, Input, HostListener, SimpleChanges } from '@angular/core';
import { Utils } from '../resources/utils';
import { SelectableItem } from '../interfaces/selectableItem';

@Directive({
  selector: '[select-item-list]'
})
export class SelectItemListDirective implements OnInit {

  // tslint:disable-next-line: no-output-on-prefix
  @Output() public onSelectItem: EventEmitter<any> = new EventEmitter();
  @Input() public list: any;
  //Select All inputs
  @Input() public type: string;
  @Input() public isSelectableFunction: Function;
  //Select only one item inputs
  @Input() public selectableItem: SelectableItem;
  @Input() public item: any;
  @Input() public checked: boolean;

  isCheckedAll = false;

  constructor(
    private elementRef: ElementRef,
    public utils: Utils
  ) { }

  public ngOnInit() {
    if (this.type === 'selectAll') {
      this.elementRef.nativeElement.insertAdjacentHTML(
        'beforeend',
        `
          <div class="check-all-title">
              Seleccionar todo
          </div>
          `
      );
    } else if (this.selectableItem && this.selectableItem.isSelectable) {
      this.updateSelectItemText();
      if (this.selectableItem.isEnabled) this.elementRef.nativeElement.classList.add('cursor-pointer');
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.list && changes.list.currentValue) {
      if (changes.list.currentValue.length === 0) this.isCheckedAll = false;
    }
    if (changes && changes.checked) {
      const previousValue = changes.checked.previousValue;
      const currentValue = changes.checked.currentValue;
      if (this.utils.isDefined(currentValue) && previousValue !== currentValue) this.updateSelectItemText();
    }
  }

  @HostListener('click') onClick() {
    if (this.type === 'selectAll') {
      this.checkAllItemsList();
      this.updateSelectAllText();
      return;
    }
    if (this.selectableItem && this.selectableItem.isSelectable && !!this.selectableItem.isEnabled) {

      this.item.checked = !this.item.checked;
      this.checked = this.item.checked;
      const currentList = this.utils.getItemsCheked(this.list);
      this.onSelectItem.emit(currentList);
      this.updateSelectItemText();
    }
  }

  private updateSelectItemText() {
    const prevElem = this.elementRef.nativeElement.querySelector('.select-item-list');
    if (prevElem) prevElem.remove();
    if (this.selectableItem && this.selectableItem.isSelectable) {
      this.elementRef.nativeElement.insertAdjacentHTML(
        'afterbegin',
        `<div class="select-item-list ${this.selectableItem.isEnabled ? this.item.checked ? 'select-item-list-checked' : 'select-item-list-enabled' : 'select-item-list-disabled'}
        ${this.selectableItem.isEnabled ? 'cursor-pointer' : ''}">
          ${this.selectableItem.isEnabled ? this.item.checked ? `<i class="fas fa-check-circle"></i>` : `<i class="far fa-circle"></i>` : `<i class="fas fa-minus-circle"></i>`}
          ${!this.selectableItem.isEnabled && this.selectableItem.errorMessage ? this.selectableItem.errorMessage : this.item.checked ? 'Deseleccionar' : 'Seleccionar'}
        </div>`
      );
    }
  }

  checkAllItemsList() {
    let listChecked;
    this.isCheckedAll = !this.isCheckedAll;
    if (this.isCheckedAll) listChecked = this.utils.selectAllItems(this.list, this.isSelectableFunction);
    else listChecked = this.utils.deselectAllItems(this.list);
    const currentList = this.utils.getItemsCheked(listChecked);
    this.onSelectItem.emit(currentList);
  }

  private updateSelectAllText() {
    const text = this.isCheckedAll ? 'Deseleccionar todo' : 'Seleccionar todo';
    this.elementRef.nativeElement.innerHTML = `
      <div class="check-all-title">
        ${text}
      </div>
    `;
  }
}
